__turbopack_context__.v({
  "disabled": "I4sMoG_disabled",
  "image": "I4sMoG_image",
  "menuItemCard": "I4sMoG_menuItemCard",
  "menuItemCardBody": "I4sMoG_menuItemCardBody",
});
